import React from "react"
import { Link } from "gatsby"

const Footer = ({ logo }) => {
  const year = new Date().getFullYear()
  return (
    <footer className="text-gray-700 body-font bg-gray-50 mt-12">
      <div className="container px-5 py-12 mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="text-sm font-medium text-gray-900 uppercase tracking-wider mb-3">
              Atendimentos
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/reiki" className="hover:text-purple-600">
                  Reiki
                </Link>
              </li>
              <li>
                <Link to="/taro-alquimico" className="hover:text-purple-600">
                  Tarô Alquímico
                </Link>
              </li>
              <li>
                <Link to="/florais" className="hover:text-purple-600">
                  Florais Alkhemy Lab
                </Link>
              </li>
              <li>
                <Link to="/barras-de-access" className="hover:text-purple-600">
                  Barras de Access
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-900 uppercase tracking-wider mb-3">
              Aprenda
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/glossario" className="hover:text-purple-600">
                  Glossário
                </Link>
              </li>
              <li>
                <Link to="/comparacoes" className="hover:text-purple-600">
                  Comparações
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-900 uppercase tracking-wider mb-3">
              Atendimento local
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/porto-alegre" className="hover:text-purple-600">
                  Porto Alegre
                </Link>
              </li>
              <li>
                <Link
                  to="/reiki-em-porto-alegre"
                  className="hover:text-purple-600"
                >
                  Reiki em Porto Alegre
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-900 uppercase tracking-wider mb-3">
              Contato
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="https://wa.me/5551993093330"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-purple-600"
                >
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/gabrielamuttoni"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-purple-600"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/gabrielamuttoni"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-purple-600"
                >
                  Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-6 flex items-center sm:flex-row flex-col">
          <Link
            to="/"
            className="flex title-font font-medium items-center md:justify-start justify-center text-gray-900"
          >
            <div style={{ width: "40px", height: "40px" }}>{logo}</div>
            <span className="ml-3 text-base">gabriela muttoni</span>
          </Link>
          <p className="text-sm text-gray-500 sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-200 sm:py-2 sm:mt-0 mt-4">
            © {year} Gabriela Muttoni — Todos direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
